import Column from '@components/column'
import NotFoundIcon from './not-found.png'
import NotFoundContentIcon from './content.png'
import {
  StyleIconWrapper,
  StyleImage,
  StyleContentImage,
  StyleCard,
  StyleCardContentWrapper,
} from './style'
import Container from '../../components/container'
import Button from '../../components/button'
import { useNavigate } from 'react-router-dom'
const PageNotFound = () => {
  const navigate = useNavigate()
  return (
    <Container>
      <Column styleColumn="height:90dvh" justifyContent="center">
        <StyleCard>
          <StyleCardContentWrapper>
            <StyleIconWrapper>
              <StyleImage src={NotFoundIcon} />
            </StyleIconWrapper>
            <Column
              alignItems="center"
              justifyContent="center"
              styleColumn="margin-top:30px;"
            >
              <StyleContentImage src={NotFoundContentIcon} />
            </Column>
            <Column
              alignItems="center"
              justifyContent="center"
              styleColumn="margin-top:30px;"
            >
              <Button
                title="Go To Home Page"
                height={40}
                onClick={() => {
                  navigate('/')
                }}
              />
            </Column>
          </StyleCardContentWrapper>
        </StyleCard>
      </Column>
    </Container>
  )
}

export default PageNotFound
